
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops/[id]",
      function () {
        return require("private-next-pages/shops/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shops/[id]"])
      });
    }
  